function cleanMenuItemNames() {
  $('.custom-sub-menu-child').each(function() {
    var text = $(this).text().trim();
    if (text.includes('_')) {
      var newText = text.split('_')[1]; // Gets the part after the underscore
      $(this).text(newText);
    }
  });
}

// Run the function when the document is ready
$(document).ready(function() {
  cleanMenuItemNames();
});


     

 var classLength = $('.previous-pagination').length;
if(classLength >= 2){
    $('.pagination__list li:nth-child(2)').remove();
}
      //HamburgerScript
       $('#toggle').click(function() {
    $(this).toggleClass('active-menu');
    $('#overlay').toggleClass('open');
});
// AddClassinBodyTag
$('.button_container').click(function() {
    if ($('body').hasClass('extra-class')) {
        $('body').removeClass('extra-class');
    } else {
        $('body').addClass('extra-class');
    }
});
// AddClassinHTMlTag
$('.button_container').click(function() {
    if ($('html').hasClass('overflow-hide')) {
        $('html').removeClass('overflow-hide');
    } else {
        $('html').addClass('overflow-hide');
    }
});

      // SLIDER--JS--STARTS

      $(document).ready(function() {
    // Swiper: Slider
        new Swiper('.swiper-container', {
            loop: true,
            infinite: true,
            autoplay: false,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            slidesPerView: 5.4,
            paginationClickable: true,
            spaceBetween: 43,
            breakpoints: {
                1916: {
                    slidesPerView: 4.4,
                    spaceBetween: 43
                },
                1370: {
                    slidesPerView: 3.4,
                    spaceBetween: 20
                },
                860: {
                    slidesPerView: 2.2,
                    spaceBetween: 30
                },
                600: {
                    slidesPerView: 2.2,
                    spaceBetween: 20
                },
                560: {
                    slidesPerView: 1.5,
                    spaceBetween: 20
                },
                440: {
                    slidesPerView: 1.4,
                    spaceBetween: 20
                },
                390: {
                    slidesPerView: 1.1,
                    spaceBetween: 20
                }
            }
        });
    });




      $(document).ready(function(){
            $('.best-col-prod').slick({
              infinite: false,
              dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
      {
        breakpoint: 870,  
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 772,  
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 550,  
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
            });
          });




          $('.toddler-slider').slick({
            centerMode: true,
            centerPadding: '20px',
            slidesToShow: 4.6,
            arrows: false,
            autoplay: false,
            infinite: true,
            autoplaySpeed: 2000,
             responsive: [
      {
        breakpoint: 992,  
        settings: {
          slidesToShow: 2.6,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 550,  
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
          });
 // ALL--SLIDER--JS--ENDS



  $(document).ready(function () {
    // Get stock quantity from the data attribute
    var stockQuantity = parseInt($('#add-to-cart-button').data('stock'), 10);

    // Check stock and update the button
    if (stockQuantity <= 0) {
      $('#add-to-cart-button')
        .prop('disabled', true) // Disable the button
        .text('Out of Stock')   // Change button text
        .css('cursor', 'not-allowed'); // Update cursor style
    }
  });




      // Left-offside-container
jQuery(document).ready(function(){
    if (jQuery(window).width() > 767) {
        var offset = jQuery('.left-offset').offset().left;
        jQuery('.auto-container').css('padding-left', offset);
    }
});

jQuery(window).resize(function(){
    if (jQuery(window).width() > 767) {
        var offset = jQuery('.left-offset').offset().left;
        jQuery('.auto-container').css('padding-left', offset);
    }
});




  ///// MEGA---MENU----JS ////
function initializeMenu() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 769) {
        // Get all menu list items (li) in the main menu
        const menuItems = document.querySelectorAll('.main-menu > li');

        menuItems.forEach(item => {
            const menuLinks = item.querySelectorAll('.sub-menu a');
            const productItems = item.querySelectorAll('.all-shirt-products > div');
            const menuHolder = item.querySelector('.sub-menu-main-holder');

            // Function to deactivate all product items within the current menu item
            function deactivateItems() {
                productItems.forEach(productItem => productItem.classList.remove('active'));
            }

            // Function to activate the first product item within the current menu item
            function activateFirstItem() {
                const firstItem = productItems[0];
                if (firstItem) {
                    firstItem.classList.add('active');
                }
            }

            // Add hover event listener to each menu link within the current menu item
            menuLinks.forEach(link => {
                link.addEventListener('mouseover', function(event) {
                    event.preventDefault(); // Prevent default link behavior

                    // Deactivate all items within this menu item
                    deactivateItems();

                    // Get the ID of the item to be activated
                    const targetId = link.getAttribute('data-id');

                    // Find the corresponding product item within this menu item and activate it
                    const targetItem = item.querySelector(targetId);
                    if (targetItem) {
                        targetItem.classList.add('active');
                    }
                });
            });

            // Check if menuHolder exists before adding mouseleave event
            if (menuHolder) {
                menuHolder.addEventListener('mouseleave', function() {
                    // Deactivate all items within this menu item
                    deactivateItems();

                    // Activate the first product item within this menu item
                    activateFirstItem();
                });
            }

            // Activate the first product item by default within this menu item
            activateFirstItem();
        });
    }
}
// Run the function on page load
initializeMenu();

// Run the function on window resize
window.addEventListener('resize', initializeMenu);








document.addEventListener('DOMContentLoaded', function() {
  const quickViewButtons = document.querySelectorAll('.quick-view');
  const quickViewModal = document.getElementById('quick-view-modal');
  const closeQuickView = document.querySelector('.close-quick-view');

  // Slider functionality
  let currentSlide = 0;

  function showSlide(index, slider) {
    const slides = slider.querySelectorAll('img');
    if (index >= slides.length) currentSlide = 0;
    if (index < 0) currentSlide = slides.length - 1;
    slider.style.transform = `translateX(-${currentSlide * 100}%)`;
  }

  quickViewButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const productHandle = this.getAttribute('data-product-handle');

      // Fetch product data
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          // Populate modal with product data
          document.querySelector('.quick-view-product-title').textContent = product.title;
          document.querySelector('.quick-view-product-price').textContent = `$${(product.price / 100).toFixed(2)}`;
          document.querySelector('.quick-view-product-description').innerHTML = product.description;
          document.querySelector('.quick-view-product-id').value = product.variants[0].id;

          // Clear existing images and add new ones
          const slider = document.querySelector('.slider');
          slider.innerHTML = '';
          product.images.forEach(image => {
            const img = document.createElement('img');
            img.src = image;
            img.alt = product.title;
            slider.appendChild(img);
          });

          // Reset slider
          currentSlide = 0;
          showSlide(currentSlide, slider);

          // Add slider navigation
          const prevButton = document.querySelector('.slider-prev');
          const nextButton = document.querySelector('.slider-next');
          prevButton.addEventListener('click', () => {
            currentSlide--;
            showSlide(currentSlide, slider);
          });
          nextButton.addEventListener('click', () => {
            currentSlide++;
            showSlide(currentSlide, slider);
          });

          // Disable slider arrows if there's only one image
          if (product.images.length <= 1) {
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';
          } else {
            prevButton.style.display = 'block';
            nextButton.style.display = 'block';
          }

          // Populate only color swatches
          const variantsContainer = document.querySelector('.quick-view-variants');
          variantsContainer.innerHTML = '';
          const colorOptions = new Set();

          product.variants.forEach(variant => {
            let color = variant.option1;
            if (variant.option2 && /color|colour/i.test(product.options[1])) {
              color = variant.option2;
            }
            if (variant.option3 && /color|colour/i.test(product.options[2])) {
              color = variant.option3;
            }

            if (!colorOptions.has(color)) {
              colorOptions.add(color);
              const swatch = document.createElement('div');
              swatch.classList.add('variant-swatch');
              swatch.style.backgroundColor = color;
              swatch.setAttribute('data-variant-id', variant.id);
              swatch.addEventListener('click', () => {
                document.querySelector('.quick-view-product-id').value = variant.id;
                document.querySelector('.quick-view-product-price').textContent = `$${(variant.price / 100).toFixed(2)}`;
                document.querySelectorAll('.variant-swatch').forEach(sw => sw.classList.remove('active'));
                swatch.classList.add('active');
              });
              variantsContainer.appendChild(swatch);
            }
          });

          // Quantity selector functionality
          const quantityInput = document.querySelector('.quantity-input');
          const quantityMinus = document.querySelector('.quantity-minus');
          const quantityPlus = document.querySelector('.quantity-plus');

          quantityMinus.addEventListener('click', () => {
            let currentValue = parseInt(quantityInput.value);
            if (currentValue > 1) {
              quantityInput.value = currentValue - 1;
            }
          });

          quantityPlus.addEventListener('click', () => {
            let currentValue = parseInt(quantityInput.value);
            quantityInput.value = currentValue + 1;
          });

          // Show the modal
          quickViewModal.style.display = 'block';
        })
        .catch(error => {
          console.error('Error fetching product data:', error);
        });
    });
  });

  // Close modal
  closeQuickView.addEventListener('click', () => {
    quickViewModal.style.display = 'none';
  });

  window.addEventListener('click', event => {
    if (event.target === quickViewModal) {
      quickViewModal.style.display = 'none';
    }
  });
});





// SCRIPT--FOR--UPDATING--CART--FOR--CUSTOM--PRODUCT
document.addEventListener('DOMContentLoaded', function() {
    function updateCartCount() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            const cartCountElement = document.querySelector('.cart-count-bubble');
            if (cartCountElement) {
                cartCountElement.textContent = data.item_count;
                
                // Show/hide the bubble based on the cart count
                if (data.item_count > 0) {
                    cartCountElement.style.display = 'flex';
                } else {
                    cartCountElement.style.display = 'none';
                }
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }

    document.querySelectorAll('.add-to-cart').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const productId = this.getAttribute('data-product-id');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            })
            .then(response => response.json())
            .then(data => {
                // Update cart count
                updateCartCount();

                // Show pop-up notification
                const notification = document.getElementById('cart-notification');
                notification.style.display = 'block';
                setTimeout(() => {
                    notification.style.display = 'none';
                }, 3000);
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });
    });

    document.querySelectorAll('.buy-now').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const productId = this.getAttribute('data-product-id');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            })
            .then(response => response.json())
            .then(data => {
                // Redirect to checkout
                window.location.href = '/checkout';
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });
    });

    // Update cart count on page load
    updateCartCount();
});



document.addEventListener('click', function(event) {
    if (event.target.classList.contains('cart__remove')) {
        event.preventDefault();

        let lineItemKey = event.target.getAttribute('data-cart-item-key'); 

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineItemKey, quantity: 0 })
        })
        .then(response => response.json())
        .then(cart => {
            location.reload(); // Refresh the cart after removal
        })
        .catch(error => console.error('Error removing item:', error));
    }
});




document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("cart-remove-button a.button").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            let parentItem = this.closest(".cart__items");
            parentItem.classList.remove("cart__items--disabled"); // Remove the disable class if present

            fetch(this.href, {
                method: "POST"
            })
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then(data => {
                console.log("Item removed", data);
                location.reload();  // Refresh cart after removal
            })
            .catch(error => console.error("Error removing item:", error));
        });
    });
});



document.addEventListener("DOMContentLoaded", function () {
  // Handle Remove Button Click
  document.querySelectorAll("cart-remove-button a").forEach(function (removeButton) {
    removeButton.addEventListener("click", function (event) {
      event.preventDefault();
      fetch(this.href, { method: "GET" }) // Send GET request to remove item
        .then(() => location.reload()) // Reload page after item is removed
        .catch(error => console.error("Error removing item:", error));
    });
  });

  // Handle Quantity Change
  document.querySelectorAll(".cart-quantity").forEach(function (quantityInput) {
    quantityInput.addEventListener("change", function () {
      let form = this.closest("form");
      if (form) {
        let formData = new FormData(form);
        fetch(form.action, {
          method: "POST",
          body: formData,
        })
          .then(() => location.reload()) // Reload page after quantity update
          .catch(error => console.error("Error updating quantity:", error));
      }
    });
  });
});